import { render, staticRenderFns } from "./sbsp-form-file-details.vue?vue&type=template&id=07fc6d34&scoped=true&"
import script from "./sbsp-form-file-details.vue?vue&type=script&lang=js&"
export * from "./sbsp-form-file-details.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-form-file-details.vue?vue&type=style&index=0&id=07fc6d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc6d34",
  null
  
)

export default component.exports